import { MouseEvent, PropsWithChildren, useCallback } from 'react';
import { InputButtonProps } from './InputButton.types';
import Box from '../../Box/Box';

function InputButton({
  onPressIn,
  children,
  ...rest
}: PropsWithChildren<InputButtonProps>) {
  const onMouseDown = useCallback(
    (e: MouseEvent<HTMLSpanElement>) => {
      e.preventDefault();
      e.stopPropagation();

      onPressIn?.();
    },
    [onPressIn],
  );

  return (
    <Box {...rest}>
      {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions */}
      <span style={{ display: 'contents' }} onMouseDown={onMouseDown}>
        {children}
      </span>
    </Box>
  );
}

export default InputButton;
